/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AgencyGroupListItem,
    AgencyGroupListItemFromJSON,
    AgencyGroupListItemFromJSONTyped,
    AgencyGroupListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyGroupListResponse
 */
export interface AgencyGroupListResponse {
    /**
     * 
     * @type {Array<AgencyGroupListItem>}
     * @memberof AgencyGroupListResponse
     */
    items?: Array<AgencyGroupListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyGroupListResponse
     */
    totalRecords?: number;
}

export function AgencyGroupListResponseFromJSON(json: any): AgencyGroupListResponse {
    return AgencyGroupListResponseFromJSONTyped(json, false);
}

export function AgencyGroupListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyGroupListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(AgencyGroupListItemFromJSON)),
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function AgencyGroupListResponseToJSON(value?: AgencyGroupListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(AgencyGroupListItemToJSON)),
        'totalRecords': value.totalRecords,
    };
}


